import moment from "moment"
import XLSX from "xlsx-with-styles"
import increaseCellNumber from "./increaseCellNumber"

export function exportJSON2Excel(
  data: object[] | undefined,
  workSheetName: string,
  filename: string,
  detail?: any,
  extraSheets?: { data: object[]; name: string }[],
  /**
   * Itog chiqariladigan ustunlar sarlavhasi. Sahifa buni bersa, faqat shu
   * ustunlar qo'shiladi — jadvaldagi "Итого" qatori bilan bir xil bo'ladi.
   * Berilmasa eski taxminiy usul ishlaydi (raqamga o'xshasa qo'shiladi),
   * shuning uchun boshqa eksportlar o'zgarishsiz qoladi.
   */
  sumColumnTitles?: string[]
) {
  if (!data || data.length === 0) return

  let exportData = [...data]
  const keys = Object.keys(exportData[0] || {})
  const explicitSums = sumColumnTitles && sumColumnTitles.length
    ? new Set(sumColumnTitles)
    : null

  if (keys.length > 0) {
    const totalRow: any = {}
    let hasNumeric = false
    // Itog chiqarilmaydigan ustunlar — ruscha/o'zbekcha sarlavhalar ham qamrab olingan
    // (ustun kalitlari lokalizatsiya qilingan sarlavhalar bo'ladi, shuning uchun
    // "phone" bilan birga "телефон", "document" bilan birga "документ" ham kerak)
    const nonSumKeys = [
      "id", "orderId", "date", "doc", "document", "article", "barcode", "code",
      "year", "month", "day", "time", "status", "type", "unit",
      "phone", "телефон", "telefon", "тел.",
      "документ", "hujjat",
      "дата", "sana",
      "артикул", "artikul",
      "штрих", "shtrix",
      "себестоимость", "tannarx",
      "приход", "prixod",
    ]
    // Avval har bir ustun uchun yig'indini (yoki null) hisoblaymiz
    const sums: Record<string, number | null> = {}
    keys.forEach((k) => {
      const isNonSum = explicitSums
        ? !explicitSums.has(k)
        : nonSumKeys.some((nk) => k.toLowerCase().includes(nk))
      const numericValues = exportData.map((item) => {
        const val = item[k]
        if (typeof val === "number") return val
        if (typeof val === "string" && val.trim() !== "") {
          /*
            Fallback rejimda (sahifa summaryKeys bermagan) matnli ustun
            xato yig'ilmasin: "Sklad 3", "Toshkent" kabi qiymatda HARF
            bo'lsa u raqam emas. Ilgari kengaytirilgan tozalash "Sklad 3"
            ni "3" ga aylantirib, Omborlar jadvalidagi nom ustuniga
            noto'g'ri itog chiqarardi (guruh xatosi). Ustun aniq
            belgilangan (explicitSums) bo'lsa harf tekshiruvi qo'llanmaydi.
          */
          if (!explicitSums && /[A-Za-zА-Яа-яЁё]/.test(val)) return null
          /*
            Formatlangan summa ("$140,000", "140 000") itogda yig'ilsin:
            faqat raqam, o'nlik nuqta va minusni qoldiramiz (7-xato).
          */
          const cleaned = val.replace(/[^\d.-]/g, "")
          // "0-003" (artikul) yoki "12-34" kabi qiymatlar NaN bo'lib chetlanadi
          if (cleaned !== "" && cleaned !== "-" && !isNaN(Number(cleaned))) {
            return Number(cleaned)
          }
        }
        return null
      }).filter((v): v is number => v !== null)

      const isNumeric = !isNonSum && numericValues.length > 0 && numericValues.length >= exportData.length * 0.5
      sums[k] = isNumeric ? Math.round(numericValues.reduce((acc, v) => acc + (v || 0), 0) * 100) / 100 : null
    })
    // "ИТОГО" yorlig'i birinchi YIG'ILMAYDIGAN ustunga yoziladi — ilgari yorliq
    // har doim 1-ustunga yozilib, 1-ustun raqamli bo'lsa (masalan, "Количество")
    // uning jami yo'qolib qolardi
    let labelPlaced = false
    keys.forEach((k) => {
      if (sums[k] !== null) {
        hasNumeric = true
        totalRow[k] = sums[k]
      } else if (!labelPlaced) {
        totalRow[k] = "ИТОГО"
        labelPlaced = true
      } else {
        totalRow[k] = ""
      }
    })
    if (hasNumeric && !exportData.some((item) => String(item[keys[0]]).toUpperCase().includes("ИТОГ"))) {
      exportData = [...exportData, totalRow]
    }
  }

  const worksheet = XLSX.utils.json_to_sheet(exportData)
  const new_worksheet = {}

  const topCellsNumber = detail ? Object.keys(detail).length : 0

  new_worksheet["!ref"] = `A1:${increaseCellNumber(
    worksheet["!ref"] ? worksheet["!ref"].split(":")[1] : "",
    topCellsNumber
  )}`

   new_worksheet["A1"] = {
      v: detail?.name,
      t: "s",
      s: {
        alignment: {
          wrapText: true,
          horizontal: "center",
          vertical: "center",
        },
        font: {
          sz: 20,
          bold: true,
        },
        fill: {
          patternType: "solid",
          fgColor: {
            rgb: "FFFFFFCC",
          },
        },
      },
    }
  if (detail) {
    // Here s = start, r = row, c=col, e= end
    let data_len = Object.keys(data[0]).length - 1
    let merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: data_len } }]
    // header
    new_worksheet["!merges"] = merge
    new_worksheet["A1"] = {
      v: detail?.name,
      t: "s",
      s: {
        alignment: {
          wrapText: true,
          horizontal: "center",
          vertical: "center",
        },
        font: {
          sz: 20,
          bold: true,
        },
        fill: {
          patternType: "solid",
          fgColor: {
            rgb: "FFFFFFCC",
          },
        },
      },
    }
    if (detail.dateInterval) {
      merge.push(
        { s: { r: 1, c: 0 }, e: { r: 1, c: 1 } },
        { s: { r: 1, c: 2 }, e: { r: 1, c: data_len } }
      )
      new_worksheet["A2"] = {
        v: detail.dateInterval[1]?"Интервал":'Дата',
        t: "s",
        s: {
          alignment: {
            wrapText: true,
            horizontal: "center",
            vertical: "center",
          },
        },
      }
      new_worksheet["C2"] = {
        v:detail.dateInterval[1]?
          new Date(detail.dateInterval[0]).toLocaleString("ru") +
          " - " +
          new Date(detail.dateInterval[1]).toLocaleString("ru"): new Date().toLocaleString("ru"),
        t: "s",
        s: {
          alignment: {
            wrapText: true,
            horizontal: "center",
            vertical: "center",
          },
        },
      }
    }
    if (detail.user) {
      merge.push(
        { s: { r: 2, c: 0 }, e: { r: 2, c: 1 } },
        { s: { r: 2, c: 2 }, e: { r: 2, c: data_len } }
      )
      new_worksheet["A3"] = {
        v: "Пользователь",
        t: "s",
        s: {
          alignment: {
            wrapText: true,
            horizontal: "center",
            vertical: "center",
          },
        },
      }
      new_worksheet["C3"] = {
        v:
          detail.user?.email ,
        //   (detail.user?.counterparty?.lastname || ""),
        t: "s",
        s: {
          alignment: {
            wrapText: true,
            horizontal: "center",
            vertical: "center",
          },
        },
      }
    }
  }

  Object.keys(worksheet)
    .filter((i) => i !== "!ref")
    .forEach((key: any) => {
      new_worksheet[increaseCellNumber(key, topCellsNumber)] = {
        ...worksheet[key],
      }
      new_worksheet[increaseCellNumber(key, topCellsNumber)].s = {
        alignment: {
          wrapText: true,
          horizontal: "center",
          vertical: "center",
        },
      }
      if (key.match(/\d/g).join("") === "1") {
        new_worksheet[increaseCellNumber(key, topCellsNumber)].s.fill = {
          patternType: "solid",
          fgColor: {
            rgb: "FFFFFFCC",
          },
        }
      }
    })

  new_worksheet["!cols"] = Object.keys(data[0]).map((obj) => {
    return {
      wch:
        Math.max(...data.map((item) => `${item[obj]}`.length), obj.length)  >
        obj.length
          ? Math.max(...data.map((item) => `${item[obj]}`.length), obj.length) +2
          : obj.length + 2,
    }
  })
  new_worksheet["!rows"] = Object.keys(data[0]).map((obj) => {
    return { hpx: 40 }
  })

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, new_worksheet, workSheetName)
  
  if (extraSheets && extraSheets.length > 0) {
    extraSheets.forEach(sheet => {
      const secondaryWorksheet = XLSX.utils.json_to_sheet(sheet.data)
      
      secondaryWorksheet["!cols"] = Object.keys(sheet.data[0] || {}).map((obj) => {
        return {
          wch:
            Math.max(...sheet.data.map((item: any) => `${item[obj]}`.length), obj.length) >
            obj.length
              ? Math.max(...sheet.data.map((item: any) => `${item[obj]}`.length), obj.length) + 2
              : obj.length + 2,
        }
      })
      
      XLSX.utils.book_append_sheet(workbook, secondaryWorksheet, sheet.name)
    })
  }
  
  XLSX.writeFile(workbook, filename)
}

export function exportTabletoExcel(
  table: any,
  workSheetName: string,
  filename: string
) {
  const worksheet = XLSX.utils.table_to_sheet(table, {
    display: true,
  })
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, workSheetName)
  XLSX.writeFile(workbook, filename)
}

export async function exportExcel2JSON(file: File) {
  const data = await readFile(file)
  const workbook = XLSX.read(data, { type: "array" })
  const firstSheetName = workbook.SheetNames[0]
  const worksheet = workbook.Sheets[firstSheetName]
  const results = XLSX.utils.sheet_to_json(worksheet, {
    defval: null,
    raw: true,
    rawNumbers: true,
  })
  return results
}

function readFile(rawFile: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsArrayBuffer(rawFile)
    reader.onload = (e) => {
      const data = e?.target?.result
      resolve(data)
    }
    reader.onerror = (err) => reject(err)
  })
}
